module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-page-header",
    class: {
      'no-subtitle': _vm.subTitle.length === 0, 'hideable': _vm.hideable
    }
  }, [_c('h1', {
    staticClass: "w-page-header__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('p', {
    staticClass: "w-page-header__description",
    class: {
      'is-invalid': _vm.error
    }
  }, [(!_vm.error) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }) : _vm._e(), (_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e47c740","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PageHeader/PageHeader.vue
// module id = 588
// module chunks = 1